import openShoe from './openShoe'
import mintShoe from './mintShoe'

const animations = {
  openShoe,
  mintShoe,
}

export default animations
